var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 65.6327 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M64.1327 13.6224V1.5H52.6837",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M1.5 55.3776V67.5H12.949",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M64.1327 55.3776V67.5H52.6837",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M1.5 13.6225V1.5H12.949",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.160251a68de2e92ed65bc2ad0b2ba6cc.svg";
export { ForwardRef as ReactComponent };